import React, { useState, useCallback } from "react";
import Header from "../components/landing/Header";
import Hero from "../components/landing/Hero";
import Problem from "../components/landing/Problem";
import WhyRfq from "../components/landing/WhyRfq";
import HowItWorks from "../components/landing/HowItWorks";
import Builder from "../components/landing/Builder";
import ConnectedWorkspace from "../components/landing/ConnectedWorkspace";
import Outcomes from "../components/landing/Outcomes";
import Faq from "../components/landing/Faq";
import FinalCta from "../components/landing/FinalCta";
import Footer from "../components/landing/Footer";
import SignupDialog from "../components/landing/SignupDialog";

export default function RfqLanding() {
  const [dialog, setDialog] = useState({ open: false, intent: "rfq" });

  const openSignup = useCallback((intent = "rfq") => {
    setDialog({ open: true, intent });
  }, []);

  const closeSignup = useCallback(() => setDialog((d) => ({ ...d, open: false })), []);

  return (
    <main className="bg-white text-[#0A0A0A]" data-testid="rfq-landing-page">
      <Header />
      <Hero />
      <Problem />
      <WhyRfq />
      <HowItWorks onCta={openSignup} />
      <Builder />
      <ConnectedWorkspace />
      <Outcomes />
      <Faq />
      <FinalCta />
      <Footer />
      <SignupDialog open={dialog.open} intent={dialog.intent} onOpenChange={closeSignup} />
    </main>
  );
}
